import { Dialog } from '@mui/material';

import ProgramQuestionForm from './index';

import type { QuestionnaireForm } from 'types';

interface ProgramQuestionModalProps {
    open: boolean;
    country: string;
    programId?: string | null;
    formName?: QuestionnaireForm;
    userId?: number;
    onClose: () => void;
}

const ProgramQuestionModal = ({
    open,
    country,
    programId = null,
    formName = 'program-question',
    userId,
    onClose,
}: ProgramQuestionModalProps) => {
    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="md"
            scroll="paper"
            slotProps={{
                paper: {
                    sx: {
                        height: { xs: '100%', sm: '85vh' },
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                        m: { xs: 0, sm: 2 },
                    },
                },
            }}
        >
            {open ? (
                <ProgramQuestionForm
                    country={country}
                    programId={programId}
                    formName={formName}
                    userId={userId}
                    onSaved={onClose}
                    onCancel={onClose}
                />
            ) : null}
        </Dialog>
    );
};

export default ProgramQuestionModal;
